import { AliasResponse, GetAliasDto } from '@/types/alias';
import { apiBase } from './apiBase';

export const aliasApi = apiBase.enhanceEndpoints({}).injectEndpoints({
  endpoints: (builder) => ({
    getAliasById: builder.query<AliasResponse, GetAliasDto>({
      query: ({ aliasId, siteId }) =>
        `external/alias/${aliasId}?siteId=${siteId}`,
      keepUnusedDataFor: 0.001,
    }),
  }),
});

export const { useGetAliasByIdQuery } = aliasApi;
